import request from "../../../request";

export default {
  actions: {
    getCities() {
      return request.get('cities');
    },

    sendActivationCodeToUser() {
      return request.post('profile/send-activation-code');
    },

    activateAccount(_, code) {
      return request.post('profile/activate-account', {
        code,
      });
    },

    createOrder(_, parameters) {
      return request.post('create-order', parameters);
    },

    updateUserSettings(_, data) {
      return request.put('profile/update-user', data);
    },

    changePassword(_, data) {
      return request.post('profile/change-password', data);
    },

    updateCompanySettings(_, data) {
      return request.post('profile/update-company', data);
    },

    updatePaymentSettings(_, data) {
      return request.post('update-payment-setting', data);
    },

    updatePackageSetting(_, data) {
      return request.post('update-package', data);
    },
    
    deletePackageSetting(_, data) {
      return request.post('delete-package', data);
    },

    createPackageSetting(_, data) {
      return request.post('create-package', data);
    },

    updateSmsPackageSetting(_, data) {
      return request.post('update-sms-package', data);
    },
    
    deleteSmsPackageSetting(_, data) {
      return request.post('delete-sms-package', data);
    },

    getEducation() {
      return request.get('get-education');
    },
    
    createEducation(_, data) {
      return request.post('create-education', data);
    },

    updateEducation(_, data) {
      return request.post('update-education', data);
    },
    
    deleteEducation(_, data) {
      return request.post('delete-education', data);
    },

    createSmsPackageSetting(_, data) {
      return request.post('create-sms-package', data);
    },

    updateSupport(_, data) {
      return request.post('update-support', data);
    },
    
    deleteSupport(_, data) {
      return request.post('delete-support', data);
    },

    createSupport(_, data) {
      return request.post('create-support', data);
    },
    
    getMySupport() {
      return request.get('get-my-supports');
    },
    
    getAllSupport(_, parameters) {
      return request.get('get-all-supports', {
        params: parameters,
      });
    },

    getSalesContract() {
      return request.get('profile/sales-contract');
    },

    updateSalesContract(_, data) {
      return request.post('profile/update-sales-contract', data);
    },

    getLeaseContract() {
      return request.get('profile/lease-contract');
    },

    updateLeaseContract(_, data) {
      return request.post('profile/update-lease-contract', data);
    },

    getOrderContract() {
      return request.get('profile/order-contract');
    },

    updateOrderContract(_, data) {
      return request.post('profile/update-order-contract', data);
    },



    getTailorContract() {
      return request.get('profile/tailor-contract');
    },
    updateTailorContract(_, data) {
      return request.post('profile/update-tailor-contract', data);
    },

    getDryContract() {
      return request.get('profile/dry-contract');
    },
    updateDryContract(_, data) {
      return request.post('profile/update-dry-contract', data);
    },

    getOrders(_, parameters) {
      return request.get('get-orders', {
        params: parameters,
      });
    },


    getSMSSettings() {
      return request.get('profile/sms-settings');
    },

    updateSMSSettings(_, data) {
      return request.post('profile/update-sms-settings', data);
    },
  }
}
